import { useState, useEffect, useRef } from 'react';
import './TestimonialsSection.css';

const TESTIMONIALS = [
  { name: 'E-Commerce Store Owner', role: 'Online Retail', initials: 'EO', color: '#6366F1', stars: 5, text: 'We used to spend 3 hours a day just answering the same questions on WhatsApp. Zepliq handles all of it now. Our team focuses on actually closing deals instead of copy-pasting replies.' },
  { name: 'Online Retailer', role: 'Shopify Store', initials: 'OR', color: '#8B5CF6', stars: 5, text: 'Order confirmations used to be a mess. Now every customer gets a WhatsApp message the second they order, and the status updates itself. Returns and follow-ups are fully automated too.' },
  { name: 'SMB Sales Manager', role: 'B2B Sales Team', initials: 'SM', color: '#0EA5E9', stars: 5, text: 'Our sales team uses the pipeline every day. The AI actually moves leads through stages on its own. It\'s like having an extra team member who works 24/7 and never makes mistakes.' },
  { name: 'Ahmed Raza', role: 'CEO, Visa Express', initials: 'AR', color: '#16A34A', stars: 5, text: 'We used to miss dozens of WhatsApp leads every day. Now the bot handles inquiries, bookings, and follow-ups around the clock. Revenue grew 40% in just 3 months after switching to Zepliq.' },
  { name: 'Michael Torres', role: 'E-Commerce Director, ShopMax', initials: 'MT', color: '#DC2626', stars: 5, text: 'We integrated Zepliq with Shopify and the results were instant. Abandoned cart recovery alone recovered $12,000 in the first month. The order confirmation pipeline is incredibly well built.' },
  { name: 'Fatima Al-Ali', role: 'Marketing Manager, Dubai Travels', initials: 'FA', color: '#D97706', stars: 5, text: 'The AI chatbot speaks to our customers in Arabic, English, and Urdu, flawlessly. Customer satisfaction jumped from 3.2 to 4.8 stars. Best investment we made this year.' },
];

const Stars = ({ count }) => (
  <div className="stars" aria-label={`${count} out of 5 stars`}>
    {Array.from({ length: count }).map((_, i) => (
      <svg key={i} width="16" height="16" viewBox="0 0 20 20" fill="#F59E0B"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/></svg>
    ))}
  </div>
);

export default function TestimonialsSection() {
  const [active, setActive] = useState(0);
  const timerRef = useRef(null);

  const restart = () => {
    clearInterval(timerRef.current);
    timerRef.current = setInterval(() => setActive(a => (a + 1) % TESTIMONIALS.length), 5000);
  };

  useEffect(() => { restart(); return () => clearInterval(timerRef.current); }, []);

  const go = i => { setActive(i); restart(); };

  return (
    <section className="testimonials section">
      <div className="testimonials__bg" aria-hidden="true" />
      <div className="container">

        <div className="testimonials__header">
          <span className="badge badge-brand">Testimonials</span>
          <h2 className="display-lg testimonials__title">
            Loved by businesses<br />
            <span className="gradient-text">around the world</span>
          </h2>
        </div>

        {/* Featured testimonial */}
        <div className="testimonials__featured" key={active}>
          <div className="testimonials__quote-icon" aria-hidden="true">"</div>
          <blockquote className="testimonials__quote">
            {TESTIMONIALS[active].text}
          </blockquote>
          <div className="testimonials__author">
            <div
              className="testimonials__avatar"
              style={{ background: TESTIMONIALS[active].color }}
              aria-hidden="true"
            >
              {TESTIMONIALS[active].initials}
            </div>
            <div>
              <div className="testimonials__name">{TESTIMONIALS[active].name}</div>
              <div className="testimonials__role">{TESTIMONIALS[active].role}</div>
            </div>
            <div className="testimonials__stars-wrap">
              <Stars count={TESTIMONIALS[active].stars} />
            </div>
          </div>
        </div>

        {/* Thumbnail nav */}
        <div className="testimonials__nav" role="list" aria-label="Testimonials navigation">
          {TESTIMONIALS.map((t, i) => (
            <button
              key={i}
              role="listitem"
              className={`testimonials__thumb ${active === i ? 'testimonials__thumb--active' : ''}`}
              onClick={() => go(i)}
              aria-label={`View testimonial from ${t.name}`}
              style={{ '--avatar-color': t.color }}
            >
              <span className="testimonials__thumb-avatar" style={{ background: t.color }}>
                {t.initials}
              </span>
              <div className="testimonials__thumb-info">
                <div className="testimonials__thumb-name">{t.name}</div>
                <div className="testimonials__thumb-role">{t.role}</div>
              </div>
            </button>
          ))}
        </div>

        {/* Progress bar */}
        <div className="testimonials__progress" aria-hidden="true">
          {TESTIMONIALS.map((_, i) => (
            <div
              key={i}
              className={`testimonials__progress-dot ${active === i ? 'testimonials__progress-dot--active' : ''}`}
              onClick={() => go(i)}
            />
          ))}
        </div>

      </div>
    </section>
  );
}
